import { render, staticRenderFns } from "./addfixman.vue?vue&type=template&id=54d8251e&scoped=true&"
import script from "./addfixman.vue?vue&type=script&lang=js&"
export * from "./addfixman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8251e",
  null
  
)

export default component.exports